const tabs = {
    actions: 'Actions',
    get_started: '開始上手',
    dashboard: '儀表板',
    applications: '全部應用',
    api_resources: 'API 資源',
    sign_in_experience: '登入與帳戶',
    connectors: '連接器',
    enterprise_sso: '企業 SSO',
    security: '安全',
    webhooks: 'Webhooks',
    organizations: '組織',
    users: '使用者管理',
    audit_logs: '稽核日誌',
    roles: '角色',
    docs: '文件',
    tenant_settings: '租戶設定',
    mfa: '多重驗證',
    customize_jwt: '自訂 JWT',
    signing_keys: '簽署金鑰',
    organization_template: '組織範本',
};
export default Object.freeze(tabs);
